export type ImageRatio = 'original' | 'dim16_9' | 'dim3_2'
export const DIMENSION_NAMES = ['xs', 'sm', 'md', 'lg', 'hd']
export const aspectRatios = {
  mobile: 10 / 23,
  desktop: 10 / 27,
}

/** Max image width at a given breakpoint. */
export type ImageBreakpoints = {
  xs?: string
  sm?: string
  md?: string
  lg?: string
  hd?: string
}
export const IMAGE_WIDTHS = [150, 300, 560, 660, 750, 880, 1024, 1350, 1440, 1720, 1920, 2048, 2700]
export type ImageSizes = {
  breakpoints?: ImageBreakpoints
  maxWidth: string | number
}
// If image breaks are undefined, make sure the width tops out 100 viewport width
const defaultBreakpoints = {
  hd: '100vw',
}
const breakpoints = {
  xs: 0,
  sm: 48,
  // 48*16 = 768px
  md: 64,
  // 64*16 = 1024px
  lg: 75,
  // 75*16 = 1200px
  hd: 90, // 88*16 = 1408px
}

/**
 * Converts a string number with a known unit type, to a unitless number in px size
 **/
export function sizeToNumber(size: string | number): number {
  if (!size) return 0
  if (typeof size === 'number') return size
  if (size.endsWith('px')) return parseInt(size.substr(0, size.length - 2), 10)
  if (size.endsWith('em')) return parseInt(size.substr(0, size.length - 2), 10) * 16
  if (size.endsWith('vw')) return (parseInt(size.substr(0, size.length - 2), 10) * 1440) / 100
  if (size.endsWith('rem')) return parseInt(size.substr(0, size.length - 3), 10) * 16
  return parseInt(size, 10)
}

/**
 * Generate the actual ratio for the the known Image ratios
 **/
export function calculateRatio(width: number = 16, height: number = 9, aspect: number) {
  return Math.min(aspect, height === 0 ? 1 : height / width === 0 ? 1 : width) // switch (aspect) {
  //   case 'dim3_2':
  //     return 2 / 3
  //   case 'dim16_9':
  //     return 9 / 16
  //   default:
  //     return height / width
  // }
}

/**
 * Generate sizes for images, while respecting Breakpoints
 **/
export function generateSizes(
  imageBreaks: ImageBreakpoints = defaultBreakpoints,
  maxWidth: string | number = '1440px',
) {
  const queries = DIMENSION_NAMES.reduce((acc, breakpoint, index) => {
    // If the breakpoint is 0, or undefined, take the next dimension
    const maxWidth = breakpoints[breakpoint] || breakpoints[DIMENSION_NAMES[index + 1]]
    const breakpointSize = imageBreaks[breakpoint]

    if (breakpointSize) {
      return `${acc}(max-width: ${maxWidth}em) ${breakpointSize}, `
    }

    return acc
  }, '')
  return queries + (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth)
}